import { debugTypes } from '../types'

const cacheWidget = (id, data) => ({ type: debugTypes.CACHE_WIDGET, payload: { id, data } })
const toggleCaching = () => ({ type: debugTypes.TOGGLE_CACHING })
const toggleLogStats = () => ({ type: debugTypes.TOGGLE_LOG_STATS })
const toggleWidgetDiagnostics = () => ({ type: debugTypes.TOGGLE_WIDGET_DIAGNOSTICS })

export const debugCreators = { cacheWidget, toggleCaching, toggleLogStats, toggleWidgetDiagnostics }
